import { useState } from "react";

const Bar = ({ label, sub, pct, votos, color, testId }) => (
  <div className="text-xs" data-testid={testId}>
    <div className="flex items-center gap-2">
      <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: color }} />
      <span className="flex-1 truncate text-slate-200" title={label}>{label}</span>
      <span className="text-slate-400 tabular-nums">{votos.toLocaleString()}</span>
      <span className="text-white tabular-nums w-12 text-right font-semibold">{pct}%</span>
    </div>
    {sub && <div className="pl-4 text-[10px] text-slate-500 truncate">{sub}</div>}
    <div className="mt-1 ml-4 h-1.5 bg-slate-800 rounded overflow-hidden">
      <div className="h-full transition-[width] duration-500" style={{ width: `${Math.min(100, pct)}%`, backgroundColor: color }} />
    </div>
  </div>
);

export const ResultBreakdown = ({ result, testPrefix = "breakdown" }) => {
  const [mode, setMode] = useState("candidatura");
  if (!result?.candidaturas?.length) return null;
  const rows = mode === "candidatura"
    ? result.candidaturas.map((c) => ({
        key: c.clave, label: c.etiqueta, pct: c.pct, votos: c.votos, color: c.color,
        sub: c.tipo === "coalicion" ? "Coalición" : c.tipo === "independiente" ? "Candidatura independiente" : null,
      }))
    : result.actores.map((a) => {
        const ind = a.clave.startsWith("CAND_IND");
        return { key: a.clave, label: ind ? a.nombre : a.clave, sub: !ind && a.nombre !== a.clave ? a.nombre : null, pct: a.pct, votos: a.votos, color: a.color };
      });
  return (
    <div className="pt-3 mt-3 border-t border-slate-800" data-testid={`${testPrefix}-panel`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Votación válida</span>
        <div className="flex bg-slate-900 border border-slate-700 rounded overflow-hidden text-[11px]">
          {["candidatura", "partido"].map((m) => (
            <button
              key={m}
              onClick={() => setMode(m)}
              className={`px-2 py-1 transition-colors ${mode === m ? "bg-blue-600 text-white" : "text-slate-300 hover:text-white"}`}
              data-testid={`${testPrefix}-mode-${m}`}
            >
              {m === "candidatura" ? "Por candidatura" : "Por partido"}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-2 max-h-64 overflow-y-auto pr-1">
        {rows.map((r) => <Bar key={r.key} {...r} testId={`${testPrefix}-row-${r.key}`} />)}
      </div>
      <div className="mt-3 grid grid-cols-3 gap-2 text-[10px] text-slate-400">
        <span>Válidos <b className="text-slate-200">{result.votos_validos?.toLocaleString()}</b></span>
        <span>Nulos <b className="text-slate-200">{result.votos_nulos?.toLocaleString()}</b></span>
        <span>Casillas <b className="text-slate-200">{result.casillas}</b></span>
      </div>
      {mode === "partido" && (
        <p className="mt-2 text-[10px] text-slate-500">Los votos marcados para varias opciones de una coalición se reparten proporcionalmente entre sus partidos.</p>
      )}
    </div>
  );
};

export const winnerInfo = (r, partyColor) => {
  if (!r) return null;
  if (r.ganador_candidatura) {
    return { label: r.ganador_candidatura.etiqueta, color: r.ganador_candidatura.color, pct: r.ganador_candidatura.pct, margen: r.margen_candidatura_pts };
  }
  if (!r.ganador) return null;
  return { label: r.ganador, color: partyColor(r.ganador), pct: r.ganador_pct, margen: r.margen_pts };
};
